import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { List, Map } from 'immutable';
import { selectOptions } from '../ActiveGame/selectors';
import { handPlayable, handReason, optionReason, sourceOption, stepTargets } from '../ActiveGame/options';
import { Button, Muted } from '../Controls';
import PickSteps from '../Picks/PickSteps';
import { startPicks, submitPicks } from '../Picks/actions';
import { TRAINER } from '../Picks/constants';
import { selectPicksSource, selectSubmittingPicks } from '../Picks/selectors';

/**
 * Playing a Trainer card from your hand: straight away when it picks nothing (Bill), otherwise one step at a time,
 * tapping a Pokémon (yours or the opponent's) or choosing cards here. Greyed out with the server's reason when it
 * can't be played.
 */
const TrainerMenu = ({ card }) => {
  const dispatch = useDispatch();
  const options = useSelector(selectOptions);
  const submitting = useSelector(selectSubmittingPicks);
  const picksSource = useSelector(selectPicksSource);

  const position = card.get('order');
  const name = card.get('name');
  const steps = card.get('trainer_steps') || List();
  const source = Map({ kind: TRAINER, handPosition: position, name });

  if (picksSource && picksSource.get('kind') === TRAINER && picksSource.get('handPosition') === position) {
    return <PickSteps />;
  }

  if (handPlayable(options, 'trainers', position)) {
    return (
      <Button $primary onClick={() => dispatch(submitPicks(source))} disabled={submitting}>
        Play {name}
      </Button>
    );
  }

  const targets = steps.size ? stepTargets(sourceOption(options, source), 0) : [];
  const reason = targets.length ? null : (handReason(options, 'trainers', position) || optionReason(undefined));

  return (
    <>
      <Button $primary onClick={() => dispatch(startPicks(source, steps))} disabled={!!reason || submitting}>
        Play {name}
      </Button>
      {reason && <Muted>{reason}</Muted>}
    </>
  );
};

TrainerMenu.propTypes = {
  card: PropTypes.instanceOf(Map).isRequired,
};

export default TrainerMenu;
